import React from 'react';
import styled from 'styled-components';

import { Button } from '~/atomic/atom/Button';
import { GiftIcon } from '~/atomic/atom/icon/GiftIcon';
import Modal from '~/atomic/molecula/Modal';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';
import { activateCatalogTimerDiscount } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.data';
import { activateCatalogTimerDiscountSelector } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.selector';
import { activateCatalogTimerDiscountActions } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.slice';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const ActivateCatalogTimerDiscountModal = () => {
  const dispatch = useAppDispatch();
  const { isShowActivateCatalogTimerDiscountModal } = useAppSelector(activateCatalogTimerDiscountSelector);

  const closeModalHandler = () => {
    dispatch(activateCatalogTimerDiscountActions.setIsShowActivateCatalogTimerDiscountModal(false));
  };

  const activateTimerDiscountFromMailHandler = () => {
    dispatch(activateCatalogTimerDiscount());
    closeModalHandler();
  };

  return (
    <SCModal
      onCancel={closeModalHandler}
      open={isShowActivateCatalogTimerDiscountModal}
    >
      <SCWrapper>
        <SCTitleWrapper>
          <SCGiftIcon />
          <SCTitle>
            Вам подарок!
          </SCTitle>
        </SCTitleWrapper>
        <SCDescription>
          В течение следующих 24 часов купите любую
          понравившуюся вам книгу со скидками до
          {' '}
          <SCPercent>
            30%
          </SCPercent>
          {' '}
          Приятного чтения!
        </SCDescription>
        <Button
          size="large"
          type="primary"
          onClick={activateTimerDiscountFromMailHandler}
        >
          Активировать скидки
        </Button>
      </SCWrapper>
    </SCModal>
  );
};

const SCTitle = styled.span`
  ${PageTitleStyle};
`;

const SCTitleWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 23px;

  > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const SCDescription = styled.p`
  ${TextRegStyle};
  line-height: 30px;
  color: var(--black-color);
  max-width: 390px;

  ${lessThan(('sm'))} {
    line-height: 20px;
  }
`;

const SCGiftIcon = styled(GiftIcon)`
  font-size: 32px;
`;

const SCWrapper = styled.div`
  background: var(--white-color);
  border-radius: 4px;
  max-width: 520px;
  width: 100%;
  padding: 32px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-right: auto;
  margin-left: auto;

  > *:not(:last-child) {
    margin-bottom: 24px;
  }

  ${lessThan(('sm'))} {
    padding: 20px 12px;

    > *:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

const SCPercent = styled.span`
  font-size: 18px;
`;

const SCModal = styled(Modal)`
   && .ant-modal-body {
    padding: 0
  }
`;
